export default {
  tertiary: '#495057',
  success: '#5cb860',
  warning: '#fb8c00',
  error: '#f55a4e',
  info: '#00d3ee',
  metalBlue: '#3f6fb6',
  metalBrown: '#795548',
  metalSkyBlue: '#e5efff',
  metalDarkBlue: '#365e99',
  metalGreyDark: '#555'
}
